// It looks like nv is defined when nvd3 is imported, but leave this alone.
/* eslint-disable no-undef */
let Bar_Chart;
let d3;
let number_with_commas;
let nvd3;
let url_to_array;
let hasProp = {}.hasOwnProperty;

Bar_Chart = require("./bar_chart").default;

// d3 = require("d3");

number_with_commas = require("../helpers/number_with_commas").default;

// nvd3 = require("nvd3");

url_to_array = require("../helpers/url_to_array").default;

class Api_Usage {
    constructor(props) {
        let $api_key_form;
        let $currently_regenerating;
        let $secret;
        let cumulative_chart;
        let fun_with_rounding;
        $api_key_form = $("#api-key-form");
        $secret = $("#secret");
        $currently_regenerating = false;
        fun_with_rounding = num =>
            number_with_commas(
                // eslint-disable-next-line no-useless-escape
                Math.round(parseFloat(num.replace(/[^\d\.\-\ ]/g, "")))
            );

        cumulative_chart = (() => {
            cumulative_chart.prototype.graph = void 0;

            cumulative_chart.prototype.remove = function() {
                return d3.selectAll(`${this.graph} > *`).remove();
            };

            cumulative_chart.prototype.render = function(data, format) {
                let graph;
                let i;
                let y_val_array;
                graph = this.graph;
                this.remove();
                i = 0;
                y_val_array = [];
                y_val_array.same = function() {
                    if (this.length > 0) {
                        i = 1;
                        while (i < this.length) {
                            if (this[i] !== this[0]) {
                                return false;
                            }
                            i++;
                        }
                    }
                    return true;
                };
                while (i < data[0].values.length) {
                    y_val_array.push(data[0].values[i].y);
                    i++;
                }
                if (y_val_array.same(y_val_array === true)) {
                    $(".not-enough-data-yet").removeClass("hidden");
                }
                return nv.addGraph(() => {
                    let chart;
                    chart = nv.models.multiChart().color(["#4c4c4c", "fd0000"]);
                    chart.xAxis
                        .showMaxMin(false)
                        .tickFormat(d => d3.time.format(format)(new Date(d)));
                    chart.tooltipContent((key, y, e, { point }) => {
                        let date;
                        date = new Date(point.x).toLocaleDateString();
                        return `<p>${date}<br>${fun_with_rounding(
                            e
                        )} calls</p>`;
                    });
                    chart.xAxis.tickValues(data[0].values.map(({ x }) => x));
                    chart.yAxis1.tickFormat(d3.format(",0f"));
                    chart.yAxis2.tickFormat(d3.format(",0f"));
                    return d3
                        .select(graph)
                        .datum(data)
                        .transition()
                        .duration(500)
                        .call(chart);
                });
            };

            function cumulative_chart(graph, data, format) {
                this.graph = graph;
                this.render(data, format);
            }

            return cumulative_chart;
        })();

        class bar_chart extends Bar_Chart {
            render(data, format) {
                let graph;
                graph = this.graph;
                this.remove();
                return nv.addGraph(() => {
                    let chart;
                    chart = nv.models
                        .discreteBarChart()
                        .x(d => d[0])
                        .y(d => d[1])
                        .staggerLabels(false)
                        .tooltips(true)
                        .showValues(false)
                        .showYAxis(false)
                        .transitionDuration(350)
                        .color(d3.scale.ordinal().range(["#4c4c4c"]));
                    chart.xAxis
                        .showMaxMin(false)
                        .tickFormat(d => d3.time.format(format)(new Date(d)));
                    chart.tooltipContent((key, y, e, { series }) => {
                        data = series.values[y - 1];
                        return `<p>${fun_with_rounding(e)} calls</p>`;
                    });
                    chart.valueFormat(d3.format(".0f"));
                    return d3
                        .select(graph)
                        .datum(data)
                        .transition()
                        .duration(500)
                        .call(chart);
                });
            }
        }

        $("#regenerate-secret-begin").on("click", function(e) {
            e.preventDefault();
            $(this).addClass("hidden");
            return $("#regenerate-secret").removeClass("hidden");
        });

        $("#regenerate-secret").on("click", function(e) {
            let $multi_button;
            let $this;
            e.preventDefault();
            $this = $(this);
            $multi_button = $(".button.multi-step");
            if ($currently_regenerating) {
                return;
            }
            $currently_regenerating = true;

            return $.ajax({
                type: "POST",
                url: `/developers/apps/${url_to_array[5]}/regenerate/`,
                data: $api_key_form.serialize(),
                success({ new_secret }) {
                    $currently_regenerating = false;
                    $secret.val(new_secret);
                    $this.addClass("hidden");
                    return $multi_button.removeClass("hidden");
                },
                error(jqXHR, textStatus, errorMessage) {
                    return console.log(errorMessage);
                }
            });
        });

        $api_key_form.on("focus", "input", function() {
            return this.select;
        });

        $("document").ready(() => {
            Promise.all([
                import(/* webpackChunkName: "nvd3" */ "d3"),
                import(/* webpackChunkName: "nvd3" */ "nvd3")
            ]).then(([module_d3, module_nvd3]) => {
                d3 = module_d3.default;
                nvd3 = module_nvd3.default;

                let json;
                let limit_line;
                let time_array;
                json = $("#graph-data").data("json");

                time_array = (time, as_object) => {
                    let i;
                    let t_array;
                    i = 0;
                    t_array = [];
                    while (i < json.usage[time].length) {
                        if (as_object === true) {
                            t_array.push({
                                x: new Date(json.usage[time][i].timestamp),
                                y: json.usage[time][i].count
                            });
                        } else {
                            t_array.push([
                                new Date(json.usage[time][i].timestamp),
                                json.usage[time][i].count
                            ]);
                        }
                        i++;
                    }
                    return t_array;
                };

                limit_line = () => {
                    let last;
                    let last_time;
                    let len;
                    let limit;
                    limit = parseInt(json.client.limit_month);
                    len = time_array("cumulative_month", true).length;
                    last = json.usage.cumulative_month[len - 1];
                    last_time = new Date(last.timestamp);
                    return [
                        {
                            x: time_array("cumulative_month", true)[0].x,
                            y: limit
                        },
                        {
                            x: last_time,
                            y: limit
                        }
                    ];
                };
                new cumulative_chart(
                    "#cumulative-chart svg",
                    [
                        {
                            key: "Total calls",
                            values: time_array("cumulative_month", true),
                            type: "bar",
                            yAxis: 1
                        },
                        {
                            key: "Monthly Call Limit",
                            values: limit_line(),
                            type: "line",
                            yAxis: 1
                        }
                    ],
                    "%d"
                );
                bar_chart = new bar_chart(
                    "#usage-chart svg",
                    [
                        {
                            key: "Hourly",
                            bar: "true",
                            values: time_array("day", false)
                        }
                    ],
                    "%I"
                );
                return $("#buttonList").on("click", "a", function(e) {
                    let day;
                    let hour;
                    let month;
                    e.preventDefault();
                    $("#buttonList .active").removeClass("active");
                    $(this)
                        .parents("li")
                        .addClass("active");
                    $("h2 em.active").removeClass("active");
                    switch ($(this).prop("id")) {
                        case "hour":
                            hour = [
                                {
                                    key: "Hourly",
                                    bar: "true",
                                    values: time_array("day", false)
                                }
                            ];
                            $("h2 em.hourly").addClass("active");
                            return bar_chart.render(hour, "%H");
                        case "day":
                            time_array("month", false);
                            day = [
                                {
                                    key: "Daily",
                                    bar: "true",
                                    values: time_array("month", false)
                                }
                            ];
                            $("h2 em.daily").addClass("active");
                            return bar_chart.render(day, "%e");
                        case "month":
                            month = [
                                {
                                    key: "Monthly",
                                    bar: "true",
                                    values: time_array("year", false)
                                }
                            ];
                            $("h2 em.monthly").addClass("active");
                            return bar_chart.render(month, "%b");
                    }
                });
            });
        });
    }
}
export default Api_Usage;
